export default [
    {
		path: '/blacklist',
		name: 'KeywordBlacklist',
		component: () => import('@/views/blacklist/KeywordBlacklist.vue'),
		meta: {
			layout: 'Default',
			abilities: [['manage','keywords']]
		}
	},
	{
		path: '/blacklist/add',
		name: 'KeywordBlacklistAdd',
		component: () => import('@/views/blacklist/KeywordBlacklistAdd.vue'),
		meta: {
			layout: 'Default',
			abilities: [['manage','keywords']]
		}
	}
]